<template>
  <v-container id="reference-term-list">
    <v-row>
      <v-col cols="8" md="8" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>

      <v-col cols="4" sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-insert-evidence
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :filter="filter"
              :municipioTarefa="municipioTarefa"
              :tasksId="taskId"
              @onSave="$emit('reload')"
            >
              <template v-slot:title> Cadastramento de Evidência </template>
            </app-modal-insert-evidence>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="evidences"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col>
                <app-modal-insert-evidence
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  :filter="filter"
                  @onSave="$emit('reload')"
                >
                  <template v-slot:title> Edição de Evidência </template>
                </app-modal-insert-evidence>
              </v-col>

              <v-col>
                <app-modal-delete-evidence
                  :payload="item"
                  @onDelete="$emit('reload')"
                >
                  <template v-slot:title> Deletar Evidência </template>
                </app-modal-delete-evidence>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertEvidence from "./ModalInsert";
import AppModalDeleteEvidence from "./ModalDelete";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppEvidenceList",
  props: {
    filter: { type: Object, required: true },
    evidences: { type: Array, required: true },
    municipioTarefa: "",
    tasksId: null,
  },
  components: {
    AppModalInsertEvidence,
    AppModalDeleteEvidence,
  },
  watch: {
    tasksId(item) {
      this.taskId = item;
    },
  },

  data() {
    return {
      headers: [
        {
          text: "#",
          value: "eixoId",
          sortable: false,
        },
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Tarefa",
          value: "tarefa.nome",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ],
      taskId: null,
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Soluções",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Tarefas",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Evidências",
          disabled: true,
          href: "termo-referencia",
        },
      ],
    };
  },
  mounted() {
    if (this.isAT) {
      this.headers = [
        {
          text: "#",
          value: "eixoId",
          sortable: false,
        },
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Atividade",
          value: "tarefa.nome",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ];
      this.breadcrumbs = [
        {
          text: "Grupos de Iniciativas",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Iniciativas",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Atividades",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Evidências",
          disabled: true,
          href: "termo-referencia",
        },
      ];
    }
    // this.loadEvidences();
    this.taskId = this.filter.tarefaId;
    this.setConsultorCondutorMunicipio(this.$route.params.id);
    this.setConsultorEspecialistaMunicipio(this.$route.params.id);
    this.setAnalistaMunicipio(this.$route.params.id);
    this.setADMunicipio(this.$route.params.id);
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "isAT",
    ]),
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
    ]),
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
